import { render, staticRenderFns } from "./KeyAdvantagesSection.vue?vue&type=template&id=bb05a294&scoped=true&"
import script from "./KeyAdvantagesSection.vue?vue&type=script&lang=js&"
export * from "./KeyAdvantagesSection.vue?vue&type=script&lang=js&"
import style0 from "./KeyAdvantagesSection.vue?vue&type=style&index=0&id=bb05a294&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb05a294",
  null
  
)

export default component.exports